const getInitials = (fullname?: string) => {
  const words = fullname?.trim().split(/\s+/).filter(Boolean) ?? [];
  return `${words[0]?.[0] ?? ''}${words[1]?.[0] ?? ''}`.toUpperCase();
};

export default getInitials;
